import request from '@/utils/request'

export function login(data) {
  return request({
    url: 'api/user/v1/sms/login',
    method: 'post',
    data
  })
}
export function sendSms(data) {
  return request({
    url: 'api/user/v1/sms/send',
    method: 'post',
    data
  })
}
// 获取图形验证码（发送短信前校验，防止短信轰炸）
export function getCaptcha(data) {
  return request({
    url: 'api/user/v1/captcha',
    method: 'post',
    data
  })
}
export function logout(data) {
  return request({
    url: 'api/agent/v1/logout',
    method: 'post',
    data
  })
}
export function getStatus(data) {
  return request({
    url: 'api/agent/v1/status',
    method: 'post',
    data
  })
}